import { render, staticRenderFns } from "./vuex-percentage-input.vue?vue&type=template&id=36b71508&scoped=true"
import script from "./vuex-percentage-input.vue?vue&type=script&lang=js"
export * from "./vuex-percentage-input.vue?vue&type=script&lang=js"
import style0 from "./vuex-percentage-input.vue?vue&type=style&index=0&id=36b71508&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b71508",
  null
  
)

export default component.exports